<script lang="ts">
    import ContentCardsSolutionOverlapCard from "./ContentCards_SolutionOverlapCard.svelte"
    import ContentCardsSolutionCard from "./ContentCards_SolutionCard.svelte"
    import ContentCardsCard from "./ContentCards_Card.svelte"
    import { apiBaseOverride } from "../../store"

    export let apiBase: string = null
    if (apiBase) {
        $apiBaseOverride = apiBase
    }

    export let block: ContentBlockEntry

    $: hasNumberCard = block.contentCards?.cards?.filter((card) => !card.icon && card.counter?.value).length > 0
    $: isSolutions = block.contentCards?.type?.startsWith("image")
    $: isSolutionOverlap = block.contentCards?.type?.startsWith("imageOverlap")
    $: overlapRight = isSolutionOverlap && block.contentCards?.type == "imageOverlapRight"
    $: overlapLeft = isSolutionOverlap && block.contentCards?.type == "imageOverlapLeft"
</script>

<!--
        Bordered Grid
        - Hier gibt es Unterschiede in der Modularität, also dieses Modul ist etwas kleinteiliger
        - Es sollte die Möglichkeit geben jedem Grid Element ein eigenes Bild zuzuordnen
        - Zusätzlich sollte möglich sein, jedem Element einen Icon zuzuordnen
        
        Animationstechnisch gibt es verschiedene Ausführungen und vielleicht kann man es auch so machen, dass man beim Einfügen des Elements Animationen mit auswählt,
        damit die jeweilige Klasse ins Grid aufgenommen wird:
        - .text-animation für das nach oben hovernde Content Text-Element
        - .headline-animation für das nach unten wandernde Headline-Element
        - oder eben nichts von beidem, dann wird nur das Icon größer
    -->

<div class="{block.contentCards?.width == 'full' ? 'container-fluid' : 'container'}">
    {#if isSolutionOverlap}
        {#each block.contentCards?.cards || [] as card, idx}
            <ContentCardsSolutionOverlapCard
                {apiBase}
                {card}
                reverse="{(overlapRight && idx % 2 == 0) || (overlapLeft && idx % 2 == 1)}"
            />
        {/each}
    {:else if isSolutions}
        <!-- Solutions overlay cards-->
        <div class="grid grid-bleed">
            {#each block.contentCards?.cards || [] as card}
                <ContentCardsSolutionCard {apiBase} {card} />
            {/each}
        </div>
    {:else}
        <div
            class="grid"
            class:bordered-grid="{block.contentCards?.border == 'line' || !block.contentCards?.border}"
            class:vp-l="{block.contentCards?.border == 'space' && !hasNumberCard}"
            class:card-grid="{block.contentCards?.border == 'card'}"
            class:gap-m="{block.contentCards?.border == 'card'}"
        >
            <!-- falls der Content Text animiert sein sollte hier Klasse .text-animation mit aufnehmen -->

            {#each block.contentCards?.cards || [] as card}
                <ContentCardsCard {apiBase} {card} {hasNumberCard} border="{block.contentCards?.border}" />
            {/each}
        </div>
    {/if}
</div>
